import Glide from '@glidejs/glide';

export default function GlideAutoCarousel(carouselId) {

    let carouselWrapper = document.querySelector(carouselId);

    if(carouselWrapper) {
        const carousel = new Glide(carouselId, {
            type: 'carousel',
            autoplay: 5000,
            animationDuration: 800,
            startAt: 0,
            gap: 15,
            perView: 3,
            breakpoints: {
                991: { 
                    perView: 1,
                    peek: {
                        before: 30,
                        after: 30
                    },
                }
            }
        })
        carousel.mount();
    }
}